import { createInput } from '@formkit/vue'
import FileInput from '../../components/FileInput/index.vue'

export const fileInput = createInput(FileInput)
